"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var styles = tslib_1.__importStar(require("./ReviewEvent.style"));

var ic_reviewevent_12x12_blue_400_svg_1 = tslib_1.__importDefault(require("../../assets/ic_reviewevent_12x12_blue_400.svg"));

function ReviewEvent() {
  return jsx_runtime_1.jsxs("span", Object.assign({
    css: styles.wrapper
  }, {
    children: [jsx_runtime_1.jsx("img", {
      src: ic_reviewevent_12x12_blue_400_svg_1.default,
      alt: "review event"
    }, void 0), "\uD6C4\uAE30 \uC774\uBCA4\uD2B8"]
  }), void 0);
}

exports.default = ReviewEvent;